import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import type { MaintenanceInfo } from '../lib/maintenance'
import './maintenance.css'

/**
 * Bakim baslamadan onceki uyari seridi.
 *
 * ## Neden kapatilabiliyor
 *
 * Serit sayfanin ustunde duruyor ve 45 dakika boyunca gorunuyor. Kapatma
 * olmasaydi kullanici onu yok saymayi ogrenirdi - bir sonraki gercek uyari
 * da fark edilmezdi. Kapatma YALNIZCA o sekme icin ve o pencere icin
 * gecerli (sessionStorage): yeni bir bakim penceresi seridi geri getiriyor.
 *
 * ## Geri sayim DAKIKA
 *
 * Saniye saniye akan bir sayac aciliyet degil huzursuzluk uretiyor;
 * kullanicinin karari ("uzun bir is baslatayim mi") dakika olcusunde.
 */
export function MaintenanceBanner({ info }: { info: MaintenanceInfo }) {
  const { t } = useTranslation()
  const [now, setNow] = useState(() => Date.now())
  const [hidden, setHidden] = useState(false)
  const key = `mnt-dismissed:${info.starts_at ?? ''}`

  useEffect(() => {
    try {
      setHidden(sessionStorage.getItem(key) === '1')
    } catch {
      // Gizli sekmede sessionStorage erisilemeyebiliyor: serit gorunur kalir.
      setHidden(false)
    }
  }, [key])

  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), 30_000)
    return () => window.clearInterval(timer)
  }, [])

  if (hidden || info.state !== 'warning' || !info.starts_at) return null

  const minutes = Math.max(0, Math.round((Date.parse(info.starts_at) - now) / 60000))

  function dismiss() {
    setHidden(true)
    try {
      sessionStorage.setItem(key, '1')
    } catch {
      // Kaydedilemezse de serit bu sekmede kapali kaliyor.
    }
  }

  return (
    <div className="mnt-banner" role="status">
      <span className="mnt-banner-dot" aria-hidden="true" />
      <span>
        {minutes > 0 ? t('maintenance.bannerIn', { count: minutes }) : t('maintenance.bannerNow')}
      </span>
      <button type="button" className="mnt-banner-close" onClick={dismiss}>
        {t('maintenance.dismiss')}
      </button>
    </div>
  )
}
